import { pushRetryableEvent } from './utils'

function formatLabel(n) {
  if (n === 0) return '$0'
  if (n >= 100) return '$100+'
  return `$${n}`
}

const TributeRangeSlider = {
  mounted() {
    this.minInput = this.el.querySelector('[data-role="min"]')
    this.maxInput = this.el.querySelector('[data-role="max"]')
    this.trackFill = this.el.querySelector('[data-role="track-fill"]')
    this.minLabel = this.el.querySelector('[data-role="min-label"]')
    this.maxLabel = this.el.querySelector('[data-role="max-label"]')

    this.minInput.addEventListener('input', () => { this.lastMoved = 'min'; this.update() })
    this.maxInput.addEventListener('input', () => { this.lastMoved = 'max'; this.update() })

    this.update(false)
  },

  updated() {
    this.update(false)
  },

  update(push = true) {
    let min = parseInt(this.minInput.value)
    let max = parseInt(this.maxInput.value)
    const rangeMax = parseInt(this.maxInput.max)

    if (min > max) {
      if (this.lastMoved === 'min') {
        this.maxInput.value = min
        max = min
      } else {
        this.minInput.value = max
        min = max
      }
    }

    const minPct = (min / rangeMax) * 100
    const maxPct = (max / rangeMax) * 100
    this.trackFill.style.left = `${minPct}%`
    this.trackFill.style.width = `${maxPct - minPct}%`

    // Keep the handle nearer to its edge on top so both remain draggable
    this.minInput.style.zIndex = min > rangeMax - max ? '5' : '4'
    this.maxInput.style.zIndex = min > rangeMax - max ? '4' : '5'

    // Update labels immediately while dragging
    this.minLabel.textContent = formatLabel(min)
    this.maxLabel.textContent = formatLabel(max)

    if (!push) return
    clearTimeout(this.debounce)
    this.debounce = setTimeout(() => {
      pushRetryableEvent(this, 'set_tribute_range', { min, max })
    }, 300)
  }
}

export default TributeRangeSlider
